import { alpha, Theme } from '@mui/material/styles';
import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style';

export const createFeatureStyles = (theme: Theme) => {
  const { palette } = theme;
  const image = new CircleStyle({
    radius: 10,
    fill: new Fill({ color: palette.secondary.main }),
    stroke: new Stroke({ color: '', width: 1 })
  });
  const polygonOutline = palette.mode === 'dark' ? palette.text.primary : palette.primary.main;

  return {
    Point: new Style({ image }),
    LineString: new Style({
      stroke: new Stroke({
        color: palette.success.main,
        width: 5
      })
    }),
    MultiLineString: new Style({
      stroke: new Stroke({
        color: palette.success.main,
        width: 1
      })
    }),
    MultiPoint: new Style({ image }),
    MultiPolygon: new Style({
      stroke: new Stroke({
        color: polygonOutline,
        width: 5
      }),
      fill: new Fill({ color: alpha(palette.warning.main, 0.1) })
    }),
    Polygon: new Style({
      stroke: new Stroke({
        color: palette.info.main,
        lineDash: [4],
        width: 3
      }),
      fill: new Fill({ color: alpha(palette.info.main, 0.1) })
    }),
    GeometryCollection: new Style({
      stroke: new Stroke({
        color: palette.warning.dark,
        width: 2
      }),
      fill: new Fill({ color: palette.warning.dark }),
      image: new CircleStyle({
        radius: 10,
        stroke: new Stroke({ color: palette.warning.dark })
      })
    }),
    Circle: new Style({
      stroke: new Stroke({
        color: palette.error.main,
        width: 2
      }),
      fill: new Fill({ color: alpha(palette.error.main, 0.2) })
    })
  };
};
